export const getTzip10Link = (url: string, payload: string): string =>
  `${url}?type=tzip10&data=${payload}`
